/*	MARK: Ai5 Machines
	============================================
	List user's machines
 */

/** Imports **/
import { inject, PLATFORM } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { MachineStatus, Machine } from './machine-schemas';
import { DataService, Request } from '../services/data-service';
import { Api } from '../services/api';
/** Constants **/

@inject(DataService, Api, Router)
export class Ai5Machines {
	/** Components methods **/

	constructor(ds, api, router){
		this.ds			= ds;
		this.api		= api;
		this.router		= router;
		this.machines 	= null;
		// Custom css
		this.status_class = {
			"InProgress":"badge-inprogress",
			"Completed"	:"badge-completed",
			"Pending"	:"badge-pending"
		}
	}

	attached(){
		// Load Remote data (machiens)
		window.setTimeout( () => { this.init() }, 300);
	}

	/** Init function **/
	init(){
		
		let machines	= this.ds.app_data.machines;
		if(!machines){
			this.getUserMachines().then(response => {
				this.handleResponseUserMachines(response);
			});
		}
		else{
			this.machines = machines;
		}
	}
	

	/** Custom methods **/
	// Get remote data (list of machines)
	getUserMachines(){
		let uid 	= this.ds.user.uid;
		let token 	= this.ds.token;
		// Create request
		let request = new Request("/api/v2/users/"+uid+"/machines/", "GET");
		request.headers["Authorization"] = "Bearer=" + token;
		// Perform remote call
		return this.api.get(request);
	}

	/** Response handlelers */
	handleResponseUserMachines(response){
		let status = response.status
		if(status === 200){
			this.machines = response.data.reverse(); // Array 
			// To Data Service
			this.ds.app_data.machines = this.machines;
		}
	}

	selectMachine(machine){
		this.ds.app_data.machine = machine;
		this.router.navigateToRoute("models.data", { id:machine._id } )
	}

	createMachine(){
		let bufferMachine = new Machine()
		bufferMachine.name = this.ds.user.username + "-model-" + Math.floor(Math.random() * 3000);
		// To DataService
		this.ds.app_data.bufferMachine = bufferMachine;
		// Next route
		this.router.navigateToRoute("models.templates")
	}


	displayDate(date){ return new Date(date).toDateString();}
}
